import { initialState } from "us.collection/reducers/ExtendedField/State";
import { ExtendedField } from "us.collection/constants";

const {
  GET_EXTENDED_FIELD,
  GET_EXTENDED_FIELD_SUCCESS,
  GET_EXTENDED_FIELD_FAIL,
  MANAGE_EXTENDED_FIELD_DRAWER,
  GET_EXTENDED_FIELD_META_DATA,
  GET_EXTENDED_FIELD_META_DATA_SUCCESS,
  GET_EXTENDED_FIELD_META_DATA_FAIL,
  UPDATE_EXTENDED_FIELD,
  UPDATE_EXTENDED_FIELD_SUCCESS,
  UPDATE_EXTENDED_FIELD_FAILURE,
  DELETE_EXTENDED_FIELD,
  DELETE_EXTENDED_FIELD_SUCCESS,
  DELETE_EXTENDED_FIELD_FAILURE,
} = ExtendedField;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_EXTENDED_FIELD:
      return Object.assign({}, state, {
        extendedFields: {
          data: state.extendedFields.data,
          isFetching: true,
        },
      });

    case GET_EXTENDED_FIELD_SUCCESS:
      return Object.assign({}, state, {
        extendedFields: {
          data: payload?.data,
          isFetching: false,
        },
      });

    case GET_EXTENDED_FIELD_FAIL:
      return Object.assign({}, state, {
        extendedFields: {
          data: [],
          isFetching: false,
        },
      });

    case MANAGE_EXTENDED_FIELD_DRAWER:
      return Object.assign({}, state, {
        drawer: payload?.data,
      });
    case GET_EXTENDED_FIELD_META_DATA:
      return Object.assign({}, state, {
        metaData: {
          infoOptions: [],
          isLoading: true,
        },
      });
    case GET_EXTENDED_FIELD_META_DATA_SUCCESS:
      return Object.assign({}, state, {
        metaData: {
          infoOptions: payload.data ?? {},
          isLoading: false,
        },
      });
    case GET_EXTENDED_FIELD_META_DATA_FAIL:
      return Object.assign({}, state, {
        metaData: {
          infoOptions: [],
          isLoading: false,
        },
      });
    case UPDATE_EXTENDED_FIELD:
      return Object.assign({}, state, {
        isFieldSaving: true,
      });
    case UPDATE_EXTENDED_FIELD_SUCCESS:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });
    case UPDATE_EXTENDED_FIELD_FAILURE:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });
    case DELETE_EXTENDED_FIELD:
      return Object.assign({}, state, {
        isFieldDeleting: true,
      });
    case DELETE_EXTENDED_FIELD_SUCCESS:
      return Object.assign({}, state, {
        isFieldDeleting: false,
      });
    case DELETE_EXTENDED_FIELD_FAILURE:
      return Object.assign({}, state, {
        isFieldDeleting: false,
      });
    default:
      return state;
  }
};
